// extracted by mini-css-extract-plugin
export default {"detail":"Detail_detail__21Z23","heading":"Detail_heading__62nah"};